<template>
  <v-card :loading="loadingCard">
      <v-card-title>
        <v-row justify="space-between">
          <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.messages') }}</span>
          <v-btn icon @click.stop="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row justify="start">
          <v-col cols="12">
            <div class="chat" v-if="hasMessages">
              <v-row v-for="(item, i) in messages" :key="i">
                <v-col cols="7" v-if="item.isMessageFromUser" class="pa-0 pl-3">
                  <div class="receivedMessage">
                    <p class="message">
                      {{ item.message }}
                    </p>
                    <p class="messageDateTime">
                      <small>{{ item.creationDateTime }}</small>
                    </p>
                  </div>
                </v-col>
                <v-col cols="7" offset="5" v-else class="pa-0 pr-5">
                  <div class="sentMessage">
                    <p class="message">
                      {{ item.message }}
                    </p>
                    <p class="messageDateTime">
                      <small>{{ item.creationDateTime }}</small>
                    </p>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row v-else justify="center">
              <h3 style="margin-bottom: 20px">{{ $t('message.info.noMessagesToShow') }}</h3>
            </v-row>
            <div style="width: 95%">
              <v-divider></v-divider>
            </div>
            <br>
            <div class="new-message">
              <v-form v-model="isFormValid" ref="chatForm">
                <v-row>
                  <v-col cols="11">
                    <v-textarea
                      v-model="chat.message"
                      rows="1"
                      outlined
                      no-resize
                      dense>
                    </v-textarea>
                  </v-col>
                  <v-col cols="1">
                    <v-btn :title="$t('label.sendMessage')" @click.stop="sendMessage" color="primary" fab depressed small icon style="margin-left: -10px" :disabled="!validForm" :loading="loadingCard">
                      <v-icon>mdi-send</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed :disabled="loadingCard" @click.stop="close">{{ $t('label.close') }}</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
import { loading, showMessage } from '../../../mixins'
import { extractDateTime, formatDateTime } from '../../../core/sharedFunctions'

export default {
  name: 'AuctionChat',
  props: {
    auctionId: Number,
    isActive: Boolean
  },
  mixins: [loading, showMessage],
  data: () => ({
    messages: [],
    isFormValid: null,
    loadingCard: false,
    chat: {
      message: ''
    }
  }),
  computed: {
    validForm () {
      return this.chat.message.length > 0
    },
    hasMessages () {
      return this.messages.length > 0
    }
  },
  methods: {
    getMessages () {
      this.loadingCard = true
      this.$proxy.get(`api/auctions/${this.auctionId}/messages`)
        .then((r) => {
          this.messages = r.data
          this.messages = this.messages.map((m) => {
            m.creationDateTime = formatDateTime(new Date(extractDateTime(m.creationDateTime)))
            return m
          })
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loadingCard = false
        })
    },
    sendMessage () {
      this.loadingCard = true
      this.chat.auctionId = this.auctionId
      this.$proxy.post(`api/auctions/${this.auctionId}/messages`, this.chat)
        .then(() => {
          this.clearForm()
          this.showMessage(this.$t('message.success.messageSent'))
          this.getMessages()
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loadingCard = false
        })
    },
    clearForm () {
      this.chat = {
        message: ''
      }
    },
    close () {
      this.clearForm()
      this.$emit('close')
    }
  },
  watch: {
    auctionId: function (newVal, oldVal) {
      if (!this.isActive) {
        return
      }
      if (newVal) {
        this.messages = []
        this.getMessages()
      }
    }
  },
  mounted () {
    this.getMessages()
  }
}
</script>

<style scoped>
  .conversations {
    height: 500px;
    width: 100%;
    overflow-y: scroll;
  }

  .chat {
    height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .new-message {
    height: 70px;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .message {
    margin: 0;
    padding: 2px 10px 0 10px;
    font-size: 12pt;
  }

  .receivedMessage {
    background-color: mediumseagreen;
    color: whitesmoke;
    border-radius: 15px 15px 15px 0;
    margin-bottom: 10px;
  }

  .sentMessage {
    background-color: #F2F2F2;
    border-radius: 15px 15px 0 15px;
    margin-bottom: 10px;
  }

  .messageDateTime {
    text-align: end;
    font-size: 10pt;
    margin-right: 5px;
  }
</style>
